import { LogLevel } from "./types"

export interface LoggerConfig {
  [key: string]: LogLevel
}

const defaultConfig: LoggerConfig = {
  '': 'info' // Default level for root namespace
}

let currentConfig: LoggerConfig = { ...defaultConfig }

export function setLoggerConfig(config: LoggerConfig) {
  currentConfig = { ...defaultConfig, ...config }
}

export function getLoggerConfig(): LoggerConfig {
  return currentConfig
}

function getEffectiveLevel(namespace: string): LogLevel {
  const parts = namespace.split('.')
  while (parts.length > 0) {
    const currentNamespace = parts.join('.')
    if (currentConfig[currentNamespace]) {
      return currentConfig[currentNamespace]
    }
    parts.pop()
  }
  return currentConfig[''] || 'info'
}

export function shouldLog(namespace: string, level: LogLevel): boolean {
  const levels: LogLevel[] = ['trace', 'debug', 'info', 'warn', 'error']
  const effectiveLevel = getEffectiveLevel(namespace)
  return levels.indexOf(level) >= levels.indexOf(effectiveLevel)
}